import { PopupEventTypes } from '../Data/PopupEventTypes';

type InstanceId = string | null | undefined;

export const signalReady = (instanceId: InstanceId, backgroundColor?: string) => {
  globalThis.parent.postMessage(
    {
      eventType: PopupEventTypes.SURVEY_READY,
      instanceId,
      backgroundColor
    },
    '*'
  );
};

export const signalSurveyCompleted = (instanceId: InstanceId) => {
  globalThis.parent.postMessage({ eventType: PopupEventTypes.SURVEY_COMPLETED, instanceId }, '*');
};

export const signalSurveyHeightChanged = (instanceId: InstanceId, newHeight: number) => {
  globalThis.parent.postMessage(
    {
      eventType: PopupEventTypes.SURVEY_HEIGHT_CHANGED,
      instanceId,
      newHeight
    },
    '*'
  );
};

// `backgroundColor` is accepted for call-site symmetry with signalReady but, as in
// the original implementation, it is intentionally not included in this payload.
export const signalSurveyPageChanged = (instanceId: InstanceId, backgroundColor?: string) => {
  globalThis.parent.postMessage(
    { eventType: PopupEventTypes.SURVEY_PAGE_CHANGED, instanceId },
    '*'
  );
};
